import { ReactNode } from "react";

import { useParams } from "react-router-dom";

import LogoDark from "@/assets/images/allears-dark.svg";
import {
  PUBLIC_EN_SITE_COOKIE_POLICY,
  PUBLIC_EN_SITE_PRIVACY_POLICY,
  PUBLIC_EN_SITE_TERMS,
  PUBLIC_SITE,
  PUBLIC_SITE_CAREERS,
  PUBLIC_SV_SITE_COOKIE_POLICY,
  PUBLIC_SV_SITE_PRIVACY_POLICY,
  PUBLIC_SV_SITE_TERMS,
} from "@/routes_new";
import Button from "@components/Button";
import Typography from "@components/Typography";

import styles from "./SharedLinkLayout.module.css";

const SharedLinkLayout = (props: { children: ReactNode }) => {
  const { language } = useParams<{ language: string }>();

  function getUrlForOtherLanguage() {
    const hrefParts = location.pathname.split("/").filter(Boolean);

    if (language) {
      hrefParts.shift();

      return (
        [language === "en" ? "/sv" : "/en", ...hrefParts].join("/") +
        location.search
      );
    } else {
      return hrefParts.join("/") + location.search;
    }
  }

  const footerPages: Array<{ label: string; href: string }> = [
    {
      label: L.PUBLIC_FOOTER_PAGES_CAREER,
      href: PUBLIC_SITE_CAREERS,
    },
    {
      label:
        language === "sv"
          ? L.PUBLIC_FOOTER_PAGES_IN_ENGLISH
          : L.PUBLIC_FOOTER_PAGES_IN_SWEDISH,
      href: getUrlForOtherLanguage(),
    },
    {
      label: L.PUBLIC_FOOTER_PAGES_TERMS,
      href: language === "sv" ? PUBLIC_SV_SITE_TERMS : PUBLIC_EN_SITE_TERMS,
    },
    {
      label: L.PUBLIC_FOOTER_PAGES_PRIVACY_POLICY,
      href:
        language === "sv"
          ? PUBLIC_SV_SITE_PRIVACY_POLICY
          : PUBLIC_EN_SITE_PRIVACY_POLICY,
    },
    {
      label: L.PUBLIC_FOOTER_PAGES_COOKIE_POLICY,
      href:
        language === "sv"
          ? PUBLIC_SV_SITE_COOKIE_POLICY
          : PUBLIC_EN_SITE_COOKIE_POLICY,
    },
  ];

  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        <div className={styles.nav__inner}>
          <LogoDark alt="All Ears" width="135" />

          <Button href="/login">{L.LOGIN_CTA}</Button>
        </div>
      </nav>

      <div className={styles.content}>{props.children}</div>

      <section className={styles.cta}>
        <div className={styles.cta__content}>
          <div className={styles.cta__content__header}>
            <Typography variant="h2" className={styles.cta__content__title}>
              {L.PUBLIC_CTA_TITLE}
            </Typography>
            <Typography className={styles.cta__content__subtitle}>
              {L.PUBLIC_CTA_DESC}
            </Typography>
          </div>

          <Button href={PUBLIC_SITE}>{L.PUBLIC_CTA_BOOK_DEMO}</Button>
        </div>
      </section>

      <footer className={styles.footer}>
        <div className={styles.footer__content}>
          {footerPages.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noreferrer noopener"
              className={styles.footer__content__link}
            >
              {link.label}
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
};

export default SharedLinkLayout;
